import ds, { dsc, ___ } from '../utils/daoService/DaoServiceClientES6Adapter'

const ebCtn = ds.QEbCtn.using(dsc)

// 通过ctnNo查询
ebCtn.getEbCtn = function (searchData) {
  if (!searchData.ebOrderId) searchData.ebOrderId = -9999
  return ebCtn
  .select(ebCtn.fieldContainer())
  .where(ebCtn.ctnNo._like$(searchData.ctnNo).and(
    ebCtn.ebOrderId.eq$(searchData.ebOrderId)
  ))
  .paging(searchData.page, searchData.limit)
  .tag('getEbCtn')
  .execute(searchData)
  }

// 通过ebOrderId查询
ebCtn.getEbCtnByEbOrderId = function (ebOrderId) {
    return ebCtn
      .select(ebCtn.fieldContainer())
      .where(ebCtn.ebOrderId.eq$(ebOrderId))
      .tag('getEbCtnByEbOrderId')
      .execute()
}

export default ebCtn
